import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-flexbox-grid';

import Container from './styled-components';

const Middle = ({ children }) => (
  <Container center="xs" middle="xs">
    <Col xs={11} md={8}>
      {children}
    </Col>
  </Container>
);

Middle.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

export default Middle;



// WEBPACK FOOTER //
// ./src/views/common/layouts/Middle/index.jsx